import { Injectable } from '@angular/core';
import { MapPainterService } from '../map-painter/map-painter.service';
import { NumberValue } from 'd3';
import * as d3 from 'd3';
import { LegendComponent } from '../../legend/legend.component';
import { DiscreteLegendComponent } from '../../discrete-legend/discrete-legend.component';
import { TimespanService } from '../timespan/timespan.service';

@Injectable({
  providedIn: 'root'
})
export class ContinuousMapPainterService extends MapPainterService {

  private heatmapInterFuncRain = d3.interpolateBlues;
  private normalizer: d3.ScaleLinear<number, number, never>;

  constructor(protected timespanService: TimespanService) { 
    super(timespanService);
  }

  /**
   * 
   * @param normalizer 
   */
  setNormalizer(normalizer: d3.ScaleLinear<number, number, never>) {
    this.normalizer = normalizer;
  }

  /**
   * Gera uma cor contínua para colorir um elemento (via ou ponto).
   * 
   * @param elemVal valor de interesse do elemento que será colorido (ex. rain_data ou indice_pluv).
   * @param lastElemVal valor do último elemento do conjunto de elementos a serem coloridos.
   * @param lowerPercentileVal valor do elemento do percentil inferior.
   * @param upperPercentileVal valor do elemento do percentil superior.
   * @param normalizer normalizador do d3js construído com os elementos que estão 
   *    entre os percentis inferior e superior, para gerar a escala de cores.
   * @return cor no formato hexadecimal
   */
  private getContinuousColor(
    elemVal: number, 
    lastElemVal: number, 
    lowerPercentileVal: number,
    upperPercentileVal: number,
    zeroColor: string = "#808080"): string {

      return "";
  }

  /**
   * 
   * @param elemVal 
   * @param lastElemVal 
   * @param compareData 
   * @param zeroColor 
   */
  getColor(elemVal: number, compareData: number[], zeroColor: string) {

    let lowerPercentileVal = compareData[0];
    let upperPercentileVal = compareData[compareData.length - 1];
    let color;
    if (elemVal == 0){
      color = zeroColor;
    }else if(elemVal < lowerPercentileVal){ //If it is in the first A-percentile
      color = this.heatmapInterFuncRain(0);
    }else if(elemVal > upperPercentileVal){ //If it is in the last B-percentile
      color = this.heatmapInterFuncRain(1);
    }
    else{
      color = this.heatmapInterFuncRain(this.normalizer(elemVal));
    }
    return color;
  }

  /**
   * 
   * @param legend 
   * @param title 
   * @param compareData 
   */
  setLegend(legend: LegendComponent, titleLines: string[], timestamp: string, compareData: number[],specialArgs?:string) {

    legend.updateColor(d3.interpolateBlues);

    let maxVal = compareData[compareData.length - 1];
    let minVal = compareData[0];

    let maxValText,minValText

    switch (specialArgs) {
      case '%':
        maxValText = `${maxVal.toFixed(2)} ${specialArgs}`
        minValText = `${minVal.toFixed(2)} ${specialArgs}`
        break;
      case 'dhm':
        maxValText = `${this.timespanService.secondsToFormattedText(maxVal)}`
        minValText = `${this.timespanService.secondsToFormattedText(minVal)}`
        break;
      default:
        maxValText = `${maxVal.toFixed(2)}`
        minValText = `${minVal.toFixed(2)}`
        break;
    }
    legend.insertText(titleLines.map(line => line.toUpperCase()), maxValText, minValText);
  }

}
